// packages/world-model/src/traits/actor/index.ts

export {
  ActorTrait,
  type IActorTrait,
  type PronounSet,
  type GrammaticalGender,
  PRONOUNS,
  HONORIFICS,
} from './actorTrait';
export { ActorBehavior, type ITakeItemResult, type IDropItemResult } from './actorBehavior';